import React from 'react';
import { useTranslation } from 'react-i18next';

export function BackgraundColorConfig({ obj, handleBackground }) {
  const { t } = useTranslation('common');
  return (
    <div className="pl-0 pr-2 py-3">
      <p className="mb-2 f-14">{t('CUSTOM_MODULE.BACKGROUND_COLOR')}</p>
      <div className="border-color-container">
        <input type="color" id="background" onChange={handleBackground} value={obj?.otherConfiguration?.background} name="background" />
      </div>
    </div>
  );
}

export default BackgraundColorConfig;
